import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import dayjs, { Dayjs } from 'dayjs';
//import utc from 'dayjs/plugin/utc';
//import timezone from 'dayjs/plugin/timezone';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';

import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';

import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { SerializedError } from '../../util/types';
import KType from './KType';
import ContextComplete from '../context/ContextComplete';
import Metadata from '../metadata/Metadata';
import MDViewer from '../markdown/Markdown';
import ParentComplete from './ParentComplete';
import {
  Ticket,
  TicketEditRequest,
  selectTicket,
  selectChildrenItems,
} from './ticketSlice';
import { useTicketViewQuery, TicketItemsResponse } from '../../api/ticket';

//dayjs.extend(utc);
//dayjs.extend(timezone);
const privateLabel = { inputProps: {'aria-label': 'Private'} };
const favoriteLabel = { inputProps: {'aria-label': 'Favorite'} };

interface ChildProps {
	ticket: TicketEditRequest;
	onTERChange: (ter: TicketEditRequest) => void;
}

export default function TicketDisplay({ticket, onTERChange}: ChildProps) {
	const [ticketV, setTicket] = useState<TicketEditRequest>(ticket);
	if (ticketV.title !== ticket.title ||
		ticketV.star !== ticket.star ||
			ticketV.kprivate !== ticket.kprivate ||
			ticketV.ktype !== ticket.ktype ||
			ticketV.tag !== ticket.tag ||
			ticketV.parent_id !== ticket.parent_id ||
			ticketV.start !== ticket.start ||
			ticketV.end !== ticket.end ||
			ticketV.planned_start !== ticket.planned_start ||
			ticketV.planned_end !== ticket.planned_end ||
			ticketV.context_id !== ticket.context_id
	   ) {
		   console.log("202501011121", ticketV);
		setTicket(ticket)
	};
	const [title, setTitle] = useState<string>(ticket.title);
	const onTitleChange = (t: string) => {
		//ticketV.title = t;
		setTitle(t);
		let f = getForm();
		f.title = t;
		onTERChange(f);
	};
	const [kprivate, setKPrivate] = useState<boolean>(ticket.kprivate);
	const onPrivateChange = (pr: boolean) => {
		//ticketV.kprivate = pr;
		setKPrivate(pr);
		let f = getForm();
		f.kprivate = pr;
		onTERChange(f);
	};
	const [star, setStar] = useState<boolean>(ticket.star);
	const onStarChange = (pr: boolean) => {
		//ticketV.star = pr;
		setStar(pr);
		let f = getForm();
		f.star = pr;
		onTERChange(f);
	};
	const [parent, setParent] = useState<string | null>(ticket.parent_id);
	const onParentChange = (p: string | null) => {
		//ticketV.parent_id = p;
		setParent(p);
		//console.log("202411220724 onParentChange", ticket);
		let f = getForm();
		f.parent_id = p;
		onTERChange(f);
	};
	// start
	const initialStart = ticket ? ticket.start : null;
	const [start, setStart] = useState<Dayjs | null>(initialStart ? dayjs(initialStart) : null);
	const onSetStart = (d: Dayjs | null) => {
		//ticketV.start = d ? d.toDate().toISOString() : null;
		let start = setStart(d);
		let f = getForm();
		f.start = d ? d.toDate().toISOString() : null;
		onTERChange(f);
	};
	const onDeleteStart = () => {
		//ticket.start = null;
		let start = setStart(null);
		let f = getForm();
		f.start = null;
		onTERChange(f);
	};
	//
	// end
	const initialEnd = ticket ? ticket.end : null;
	const [end, setEnd] = useState<Dayjs | null>(initialEnd ? dayjs(initialEnd) : null);
	const onSetEnd = (d: Dayjs | null) => {
		//ticketV.end = d ? d.toDate().toISOString() : null;
		let end = setEnd(d);
		let f = getForm();
		f.end = d ? d.toDate().toISOString() : null;
		onTERChange(f);
	};
	const onDeleteEnd = () => {
		//ticket.end = null;
		let end = setEnd(null);
		let f = getForm();
		f.end = null;
		onTERChange(f);
	};
	//
	// planned_start
	const initialPlannedStart = ticket ? ticket.planned_start : null;
	const [plannedStart, setPlannedStart] = useState<Dayjs | null>(initialPlannedStart ? dayjs(initialPlannedStart) : null);
	const onSetPlannedStart = (d: Dayjs | null) => {
		//ticketV.planned_start = d ? d.toDate().toISOString() : null;
		let plannedStart = setPlannedStart(d);
		let f = getForm();
		f.planned_start = d ? d.toDate().toISOString() : null;
		onTERChange(f);
	};
	const onDeletePlannedStart = () => {
		//ticket.planned_start = null;
		let start = setPlannedStart(null);
		let f = getForm();
		f.planned_start = null;
		onTERChange(f);
	};
	//
	// planned_end
	const initialPlannedEnd = ticket ? ticket.planned_end : null;
	const [plannedEnd, setPlannedEnd] = useState<Dayjs | null>(initialPlannedEnd ? dayjs(initialPlannedEnd) : null);
	const onSetPlannedEnd = (d: Dayjs | null) => {
		//ticketV.planned_end = d ? d.toDate().toISOString() : null;
		let plannedEnd = setPlannedEnd(d);
		let f = getForm();
		f.planned_end = d ? d.toDate().toISOString() : null;
		onTERChange(f);
	};
	const onDeletePlannedEnd = () => {
		//ticket.planned_end = null;
		let end = setPlannedEnd(null);
		let f = getForm();
		f.planned_end = null;
		onTERChange(f);
	};
	// level
	const [ktype, setKType] = useState<string | null>(ticket.ktype);
	const onKTypeChange = (ktype: string | null) => {
		//ticketV.ktype = ktype;
		let _ktype = setKType(ktype);
		let f = getForm();
		f.ktype = ktype;
		onTERChange(f);
	};
	// tag
	const [tag, setTag] = useState<string>(ticket.tag);
	const onTagChange = (t: string) => {
		//ticketV.title = t;
		setTag(t);
		let f = getForm();
		f.tag = t;
		onTERChange(f);
	};
	// context
	const [context, setContext] = useState<string | null>(ticket.context_id);
	const onContextChange = (context: string | null) => {
		//ticketV.context_id = context;
		setContext(context);
		let f = getForm();
		f.context_id = context;
		onTERChange(f);
	};
	let initContent = ticket ? ticket.content : "";
	let [contentValue, setContent] = React.useState(initContent);
	const onContentChange = (content: string) => {
		let contentValue = setContent(content);
		//ticketV.content = content;
		let f = getForm();
		f.content = content;
		onTERChange(f);
	};
	const getForm = () => {
		return {
			id: ticket.id,
			old_id: ticket.old_id,
			user_id: ticket.user_id,
			admin_id: ticket.admin_id,
			organization_id: ticket.organization_id,
			team_id: ticket.team_id,
			kprivate: kprivate,

			start: start ? start.toISOString() : null,
			end: end ? end.toISOString() : null,
			planned_start: plannedStart ? plannedStart.toISOString() : null,
			planned_end: plannedEnd ? plannedEnd.toISOString() : null,
			deadline: null,

			parent_id: parent,
			context_id: context,
			area_id: null,
			space_id: null,
			ktype: ktype,
			star: star,
			title: title,
			tag: tag,
			content: contentValue,
			content_type: "Markdown",
		};
	};
	return (
		<Grid container spacing={1}>
			<Grid size={{ xs:12, md:8 }}>
				<TextField
				label="title"
				fullWidth
				value={title}
					onChange={(e) => {onTitleChange(e.target.value)}}
				/><br /><br />
			</Grid>
			<Grid size={{ xs:12, md:4 }}>
				private:
				<Checkbox {...privateLabel} checked={kprivate} icon={<LockOpenIcon />} checkedIcon={<LockIcon/>}
					onChange={(event) => onPrivateChange(event.target.checked)}
				/>
				favorite:
				<Checkbox {...favoriteLabel} checked={star} icon={<StarBorderIcon />} checkedIcon={<StarIcon/>}
					onChange={(event) => onStarChange(event.target.checked)}
				/><br />
			</Grid>
			<Grid size={{ xs:12 , md: 4 }}>
				<Grid container spacing={1}>
					<Grid size={12}>
						<KType ktype={ktype} onChange={onKTypeChange} />
						<TextField
							label="tag"
							fullWidth
							value={tag}
							onChange={(e) => {onTagChange(e.target.value)}}
						/>				
					</Grid>
					<Grid size={12}>
						<TextField size="small" label="admin"/><br />
					</Grid>
					<Grid size={12}>
						<TextField size="small" label="organization" /><br />
					</Grid>
					<Grid size={12}>
						<TextField size="small" label="team" /><br />
					</Grid>
				</Grid>
			</Grid>

			<Grid size={{ xs:12, md:4 }}>
				<ParentComplete childType={ktype} id={parent} onChange={onParentChange}/><br />
				<ContextComplete context={context} onChange={onContextChange}/><br /><br />
				<TextField size="small" label="area"/><br /><br />
				<TextField size="small" label="space"/><br /><br />
			</Grid>

			<Grid size={{ xs:12, md:4 }}>
				<Grid container spacing={1}>
					<Grid size={10}>
						<DateTimePicker
							label="start"
							value={start}
							slotProps={{textField: { size: 'small' }}}
							onChange={(newValue) => onSetStart(newValue)}
							ampm={false}
							format={'YYYY/MM/DD HH:mm'}
						/>
					</Grid>
					<Grid size={2}>
						<IconButton
							aria-label="delete"
							size="small"
							onClick={onDeleteStart}
						><DeleteIcon fontSize="small" />
						</IconButton>
					</Grid>
					<Grid size={10}>
						<DateTimePicker
							label="end"
							value={end}
							slotProps={{textField: { size: 'small' }}}
							onChange={(newValue) => onSetEnd(newValue)}
							ampm={false}
							format={'YYYY/MM/DD HH:mm'}
						/>
					</Grid>
					<Grid size={2}>
						<IconButton
							aria-label="delete"
							size="small"
							onClick={onDeleteEnd}
						><DeleteIcon fontSize="small" />
						</IconButton>
					</Grid>
					<Grid size={10}>
						<DateTimePicker
							label="planned start"
							value={plannedStart}
							slotProps={{textField: { size: 'small' }}}
							onChange={(newValue) => onSetPlannedStart(newValue)}
							ampm={false}
							format={'YYYY/MM/DD HH:mm'}
						/>
					</Grid>
					<Grid size={2}>
						<IconButton
							aria-label="delete"
							size="small"
							onClick={onDeletePlannedStart}
						><DeleteIcon fontSize="small" />
						</IconButton>
					</Grid>
					<Grid size={10}>
						<DateTimePicker
							label="planned end"
							value={plannedEnd}
							slotProps={{textField: { size: 'small' }}}
							onChange={(newValue) => onSetPlannedEnd(newValue)}
							ampm={false}
							format={'YYYY/MM/DD HH:mm'}
						/>
					</Grid>
					<Grid size={2}>
						<IconButton
							aria-label="delete"
							size="small"
							onClick={onDeletePlannedEnd}
						><DeleteIcon fontSize="small" />
						</IconButton>
					</Grid>
				</Grid>
			</Grid>

			<Grid size={12}>
				<TextField
					id="ticket-edit-content"
					label="Content"
					variant="standard"
					defaultValue={initContent}
					placeholder="Placeholder"
					inputProps={{style: {fontFamily:'courier new'}}}
					multiline
					fullWidth
					onChange={(e) => {onContentChange(e.target.value)}}
					sx={{fontFamily: 'courrier'}}
				/>
			</Grid>
		</Grid>
	);
}
